import React from 'react';

import { useOfferContext } from '../../../context';
import { Card } from '../../../components/Card';
import { GalleryContainer } from '../GalleryContainer';
import { ThumbnailsContainer } from '../ThumbnailsContainer';
import { OfferGeneralInfoContainer } from '../OfferGeneralInfoContainer';
import { AgentContainer } from '../AgentContainer';
import { ControlsContainer } from '../ControlsContainer';
import { VASContainer } from '../VAS/VASContainer';
import { PessimizationTogglerContainer } from '../PessimizationTogglerContainer';

export function OfferCardContainer() {
  const {
    isTop,
    isColored,
    offer: { fullUrl },
    api: { isPopupsOpened, onPageJumped },
  } = useOfferContext();

  const handleCardClick = React.useCallback(() => {
    if (isPopupsOpened()) {
      return;
    }
    onPageJumped('card_detail_in_newlist');
    window.open(fullUrl, '_blank');
  }, [fullUrl, isPopupsOpened, onPageJumped]);

  return (
    <Card
      href={fullUrl}
      onClick={handleCardClick}
      colored={isColored}
      promoted={isTop}
      gallery={<GalleryContainer />}
      thumbnails={<ThumbnailsContainer />}
      content={<OfferGeneralInfoContainer />}
      agent={<AgentContainer />}
      controls={<ControlsContainer />}
      vas={<VASContainer />}
      pessimization={<PessimizationTogglerContainer />}
      comment={null}
    />
  );
}
